import { GetShopProductVariantBySelectedOptionsQuery } from './getShopProductVariantBySelectedOptions';

type GetShopProductVariantBySelectedOptionsQueryWrapper = {
  data: GetShopProductVariantBySelectedOptionsQuery;
  extensions: never;
};

export default {
  data: {
    shopProductBySkuId: {
      id: '40',
      variantBySelectedOptions: {
        sku: '2413822',
        url: 'http://localhost:5000/product/fakeSlug/fakeProductId?color=fakeColor&size=fakeSize',
        media: [
          {
            altText: 'flat_front',
            category: 'flat_image',
            group: 'flat_image',
            label: 'flat_front',
            contentType: 'IMAGE',
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1639691842/zfrnv7y1isj73vwiggar.jpg',
            modelSize: null,
            position: 1,
          },
          {
            altText: 'flat_back',
            category: 'flat_image',
            group: 'flat_image',
            label: 'flat_back',
            contentType: 'IMAGE',
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1639691842/zfrnv7y1isj73vwiggar.jpg',
            modelSize: null,
            position: 2,
          },
          {
            altText: 'flat_detail',
            category: 'flat_image',
            group: 'flat_image',
            label: 'flat_detail',
            contentType: 'IMAGE',
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1639691842/zfrnv7y1isj73vwiggar.jpg',
            modelSize: null,
            position: 3,
          },
          {
            altText: 'style_card',
            category: 'style_card',
            group: 'flat_image',
            label: 'style_card',
            contentType: 'IMAGE',
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1639691842/zfrnv7y1isj73vwiggar.jpg',
            modelSize: null,
            position: 4,
          },
        ],
        __typename: 'ShopProductVariant',
      },
      __typename: 'ShopProduct',
    },
  },
} as GetShopProductVariantBySelectedOptionsQueryWrapper;
